import { __ } from "@wordpress/i18n";

export const alignItemsOptions = [
  {
    label: (
      <span data-tooltip={__("Start")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="3" width="6" height="18" />
          <rect x="11" y="3" width="10" height="6" />
          <line x1="0" y1="3" x2="24" y2="3" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "flex-start",
  },
  {
    label: (
      <span data-tooltip={__("Center")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="3" width="6" height="18" />
          <rect x="11" y="9" width="10" height="6" />
          <line x1="0" y1="12" x2="24" y2="12" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "center",
  },
  {
    label: (
      <span data-tooltip={__("End")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="3" width="6" height="18" />
          <rect x="11" y="15" width="10" height="6" />
          <line x1="0" y1="21" x2="24" y2="21" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "flex-end",
  },
  {
    label: (
      <span data-tooltip={__("Stretch")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="3" width="6" height="18" />
          <rect x="11" y="3" width="10" height="18" />
          <line x1="0" y1="3" x2="24" y2="3" stroke="currentColor" />
          <line x1="0" y1="21" x2="24" y2="21" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "stretch",
  },
];

export const directionOptions = [
  {
    label: (
      <span data-tooltip={__("Row")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M3 10h6v4H3v-4zm8 0h10v4H11v-4z" />
          <path d="M20 12l-4-4v8l4-4z" />
        </svg>
      </span>
    ),
    value: "row",
  },
  {
    label: (
      <span data-tooltip={__("Row Reverse")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M15 10h6v4h-6v-4zm-12 0h10v4H3v-4z" />
          <path d="M4 12l4-4v8l-4-4z" />
        </svg>
      </span>
    ),
    value: "row-reverse",
  },
  {
    label: (
      <span data-tooltip={__("Column")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M10 3h4v6h-4V3zm0 8h4v10h-4V11z" />
          <path d="M12 20l-4-4h8l-4 4z" />
        </svg>
      </span>
    ),
    value: "column",
  },
  {
    label: (
      <span data-tooltip={__("Column Reverse")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M10 3h4v10h-4V3zm0 12h4v6h-4v-6z" />
          <path d="M12 4l-4 4h8l-4-4z" />
        </svg>
      </span>
    ),
    value: "column-reverse",
  },
];

export const wrapOptions = [
  {
    label: (
      <span data-tooltip={__("No Wrap")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="4" />
          <rect x="3" y="10" width="18" height="4" />
          <rect x="3" y="16" width="18" height="4" />
        </svg>
      </span>
    ),
    value: "nowrap",
  },
  {
    label: (
      <span data-tooltip={__("Wrap")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="4" width="12" height="4" />
          <rect x="3" y="10" width="18" height="4" />
          <rect x="15" y="16" width="6" height="4" />
        </svg>
      </span>
    ),
    value: "wrap",
  },
  {
    label: (
      <span data-tooltip={__("Wrap Reverse")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="9" y="4" width="12" height="4" />
          <rect x="3" y="10" width="18" height="4" />
          <rect x="3" y="16" width="6" height="4" />
        </svg>
      </span>
    ),
    value: "wrap-reverse",
  },
];

export const justifyContentOptions = [
  {
    label: (
      <span data-tooltip={__("Start")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="8" width="4" height="8" />
          <rect x="9" y="8" width="4" height="8" />
          <line x1="3" y1="4" x2="3" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "flex-start",
  },
  {
    label: (
      <span data-tooltip={__("Center")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="7" y="8" width="4" height="8" />
          <rect x="13" y="8" width="4" height="8" />
          <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "center",
  },
  {
    label: (
      <span data-tooltip={__("End")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="11" y="8" width="4" height="8" />
          <rect x="17" y="8" width="4" height="8" />
          <line x1="21" y1="4" x2="21" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "flex-end",
  },
  {
    label: (
      <span data-tooltip={__("Space Between")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="3" y="8" width="4" height="8" />
          <rect x="17" y="8" width="4" height="8" />
          <line x1="3" y1="4" x2="3" y2="20" stroke="currentColor" />
          <line x1="21" y1="4" x2="21" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "space-between",
  },
  {
    label: (
      <span data-tooltip={__("Space Around")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="5" y="8" width="4" height="8" />
          <rect x="15" y="8" width="4" height="8" />
          <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "space-around",
  },
  {
    label: (
      <span data-tooltip={__("Space Evenly")}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <rect x="6" y="8" width="4" height="8" />
          <rect x="14" y="8" width="4" height="8" />
          <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" />
        </svg>
      </span>
    ),
    value: "space-evenly",
  },
];
